import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Check for credentials passed via URL query parameters from the Angular app.
// This bypasses the iframe/postMessage credential exchange which is broken
// by Chrome's third-party storage partitioning (Chrome 115+).
// Must run BEFORE React renders so that React Admin's checkAuth() sees the token.
const params = new URLSearchParams(window.location.search);
const token = params.get('token');
const productionParam = params.get('production');

if (token && productionParam) {
  try {
    const production = JSON.parse(atob(productionParam));
    if (production && typeof production === 'object' && production.id) {
      localStorage.setItem('auth', token);
      localStorage.setItem('production', JSON.stringify(production));
      // Clean up URL params and redirect to the root hash route
      window.history.replaceState({}, '', window.location.pathname + '#/');
    }
  } catch (e) {
    console.warn('Failed to parse credentials from URL:', e);
  }
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
